export default '2.40.1';